import { useTable } from 'context/table-context'
import classNames from 'helpers/class-names'
import { FC, HTMLAttributes, useEffect } from 'react'

interface Props extends HTMLAttributes<HTMLTableSectionElement> {}

export const TableFooter: FC<Props> = ({ children, ...props }) => {
  const { setFooter } = useTable()

  useEffect(() => {
    setFooter(
      <div
        {...props}
        className={classNames(
          'sticky bottom-0 z-10 truncate bg-gray-100 p-2 tracking-normal',
          props.className,
        )}>
        {children}
      </div>,
    )
  }, [children])

  return null
}
